import { useEffect, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { searchGemeenten } from '../../../helpers/pdok/fetchPdok'

// Step 1 — multiselect cities. Search any NL gemeente (keyless PDOK); selected
// cities show as removable chips. Persists to Wervingsacties.Gemeenten[] via props.
const CitySelect = ({ selected, onAdd, onRemove, canEdit }) => {
    const [query, setQuery] = useState('')
    const [results, setResults] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const q = query.trim()
        if (q.length < 2) {
            setResults([])
            return
        }
        const controller = new AbortController()
        setLoading(true)
        const timer = setTimeout(() => {
            searchGemeenten(q, controller.signal)
                .then(setResults)
                .catch((err) => { if (err.name !== 'AbortError') console.error('PDOK gemeente search failed', err) })
                .finally(() => setLoading(false))
        }, 250)
        return () => {
            controller.abort()
            clearTimeout(timer)
        }
    }, [query])

    const selectedCodes = selected.map((s) => s.GemeenteCode)
    const visibleResults = results.filter((r) => !selectedCodes.includes(r.GemeenteCode))

    return (
        <div className='wa-step'>
            <h3>1. Steden</h3>
            <div className='wa-chips'>
                {selected.length === 0 && <p className='wa-empty'>Nog geen steden gekozen.</p>}
                {selected.map((g) => (
                    <span key={g.GemeenteCode} className='wa-chip'>
                        {g.Naam}
                        {canEdit && (
                            <CloseIcon className='wa-chip-remove' onClick={() => onRemove(g.GemeenteCode)} />
                        )}
                    </span>
                ))}
            </div>
            {canEdit && (
                <div className='wa-search'>
                    <input
                        type='text'
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        placeholder='Zoek een stad (gemeente)'
                    />
                    {loading && <p className='wa-hint'>Zoeken…</p>}
                    {visibleResults.length > 0 && (
                        <div className='wa-search-results'>
                            {visibleResults.map((r) => (
                                <div
                                    key={r.GemeenteCode}
                                    className='wa-option'
                                    onClick={() => { onAdd(r); setQuery(''); setResults([]) }}
                                >
                                    {r.Naam}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

export default CitySelect
